import {makeApolloClientCall} from "../../Api/makeApolloApiCall";
import _ from "lodash";
import {shouldReloadCache} from "./cacheUtil";

export const SALESFORCE_STORES_QUERY = `{ salesforceStores { notActiveStore storeId } }`;

const SALESFORCE_STORES_MAP_KEY = 'salesforceStoresCache';

const ONE_HOUR = 1;

const toNotActiveStoreMap = (salesforceStores) => salesforceStores
    .filter(store => store.notActiveStore === true)
    .reduce((accumulator, store) => ({...accumulator, [Number(store.storeId)]: true}), {});

export const loadSalesforceStores = (breakCache = false) => {

    if (!shouldReloadCache(SALESFORCE_STORES_MAP_KEY, ONE_HOUR) && !breakCache) {
        return true;
    }

    return makeApolloClientCall(SALESFORCE_STORES_QUERY)
        .then(result => {
            const salesforceStores = result?.salesforceStores;
            if (!Array.isArray(salesforceStores)) {
                return;
            }
            window.localStorage.setItem(SALESFORCE_STORES_MAP_KEY, JSON.stringify({
                'salesforceStoresData': toNotActiveStoreMap(salesforceStores),
                "cacheTime": Date.now(),
            }));
        }).finally(() => getSalesforceStores.cache.clear());
};

export const getSalesforceStores = _.memoize(() => {
    try {
        return JSON.parse(window.localStorage.getItem(SALESFORCE_STORES_MAP_KEY))?.salesforceStoresData ?? {};
    } catch {
        return {};
    }
});
